import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Chat from "./pages/Chat";
import RestaurantSelect from "./pages/RestaurantSelect";
import SelectRestaurant from "./pages/SelectRestaurant";
import AdminPanel from "./pages/AdminPanel";
import QRCard from "./pages/QRCard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RestaurantSelect />} />
          <Route path="/select" element={<SelectRestaurant />} />
          <Route path="/treadwell" element={<Chat restaurant="treadwell" />} />
          <Route path="/notl" element={<Chat restaurant="notl" />} />
          <Route path="/treadwelladmin" element={<AdminPanel restaurant="treadwell" />} />
          <Route path="/notladmin" element={<AdminPanel restaurant="notl" />} />
          <Route path="/qr/notl" element={<QRCard restaurant="notl" />} />
          <Route path="/qr/treadwell" element={<QRCard restaurant="treadwell" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
